import { render } from "./indexAllotmentComponent.vue?vue&type=template&id=2efa354c"
import script from "./indexAllotmentComponent.vue?vue&type=script&lang=js"
export * from "./indexAllotmentComponent.vue?vue&type=script&lang=js"

import "./indexAllotmentComponent.vue?vue&type=style&index=0&id=2efa354c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__